import React from 'react';
import cx from 'classnames';
import { useCart } from '@shared/cart-react';
import s from './referralBanner.module.scss';

const ReferralBanner = () => {
  const cartInstance = useCart();
  const { isReferral } = cartInstance;
  return (
    <div
      className={cx(s.referral, {
        [s.referralHide]: !isReferral,
      })}
    >
      <div className={s.referralWrapper}>
        <p className={s.referralText}>
          Your $25 referral discount has been applied!
        </p>
      </div>
    </div>
  );
};

ReferralBanner.propTypes = {};

export default ReferralBanner;
